import { useQuery } from "@tanstack/react-query";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../api/client";
import { oauthStorageKeys } from "./OAuthCallbackPage";

// createOAuthState binds the Keeper callback to the browser that started login.
// 生成随机状态，绑定发起登录和接收回调的浏览器。
function createOAuthState(): string {
  const values = crypto.getRandomValues(new Uint8Array(24));
  return Array.from(values, (value) => value.toString(16).padStart(2, "0")).join("");
}

// LoginPage delegates account admission and role assignment to Keeper.
// 登录页把账号准入和角色分配交给 Keeper。
export function LoginPage() {
  const [search] = useSearchParams();
  const oauth = useQuery({ queryKey: ["oauth-config"], queryFn: api.oauthConfig, retry: false });

  const login = () => {
    if (!oauth.data) return;
    const state = createOAuthState();
    const returnTo = search.get("returnTo");
    sessionStorage.setItem(oauthStorageKeys.state, state);
    sessionStorage.setItem(oauthStorageKeys.returnTo, returnTo?.startsWith("/manage/") ? returnTo : "/manage/overview");
    const target = new URL(oauth.data.authorize_url);
    target.searchParams.set("client_id", oauth.data.client_id);
    target.searchParams.set("response_type", "code");
    target.searchParams.set("redirect_uri", oauth.data.redirect_uri);
    target.searchParams.set("state", state);
    window.location.assign(target.toString());
  };

  return (
    <main className="login-page">
      <section className="login-intro">
        <div className="brand-lockup"><span>MM</span><strong>Moras Moneyking</strong></div>
        <div>
          <p className="login-kicker">K2Lab Internal</p>
          <h1>Moras Moneyking</h1>
          <p>模型网关控制台</p>
        </div>
        <div className="login-footnote">Secure Console</div>
      </section>
      <section className="login-form-pane">
        <div className="login-form">
          <div className="form-heading"><ShieldCheck size={22} /><div><h2>登录控制台</h2><p>使用 K2Lab Keeper 账号继续</p></div></div>
          <div className="login-sso-note"><strong>统一身份登录</strong><span>账号准入和角色由 Keeper 管理。</span></div>
          {oauth.isError ? <div className="form-error">{oauth.error.message}</div> : null}
          <button type="button" className="primary-button login-submit" disabled={oauth.isPending || oauth.isError} onClick={login}>
            {oauth.isPending ? "正在连接 Keeper" : "使用 Keeper 登录"}<ArrowRight size={17} />
          </button>
        </div>
      </section>
    </main>
  );
}
